import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { DropdownMenuLink } from '@jutro/router';
import { CONSTANTS, WMICDriverUtil } from 'wmic-pe-portals-utils-js';
import { RISK_PATHS } from 'wmic-pe-portals-utils-js/StringConstants';
import messages from './WMICAddNewDriverButton.messages';
import { DropdownMenuButton } from '@jutro/legacy/components';

function WMICAddNewDriverButton(props) {
    const { additionalNamedInsureds, isEditing, jobVM, onClick } = props;
    const translator = useTranslator();
    const drivers = _.get(jobVM, `${RISK_PATHS.DRIVERS_PATH}.value`, []);
    const pni = jobVM.baseData.primaryNamedInsured_WMIC.value;

    return (
        <DropdownMenuButton
            id="addNewDriverButton"
            buttonText={translator(messages.addNewDriver)}
            icon="mi-add"
            disabled={isEditing}
        >
            {WMICDriverUtil.canContactBeAddedToDrivers(drivers, pni) && (
                <DropdownMenuLink onClick={() => onClick(drivers.length, pni, CONSTANTS.INSURED_ROLES.PRIMARY_INSURED)}>
                    {pni.displayName}
                </DropdownMenuLink>
            )}
            {additionalNamedInsureds.map(
                (ani, index) =>
                    WMICDriverUtil.canContactBeAddedToDrivers(drivers, ani.value) && (
                        <DropdownMenuLink
                            onClick={() =>
                                onClick(
                                    drivers.length,
                                    _.get(jobVM, `${CONSTANTS.ANIS_PATH}.value[${index}]`),
                                    CONSTANTS.INSURED_ROLES.ADDITIONAL_INSURED
                                )
                            }
                        >
                            {ani.displayName.value}
                        </DropdownMenuLink>
                    )
            )}
            <DropdownMenuLink onClick={() => onClick(drivers.length)}>
                {translator(messages.addNewDriver)}
            </DropdownMenuLink>
        </DropdownMenuButton>
    );
}

WMICAddNewDriverButton.propTypes = {
    additionalNamedInsureds: PropTypes.arrayOf(PropTypes.object).isRequired,
    isEditing: PropTypes.bool.isRequired,
    jobVM: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default WMICAddNewDriverButton;
